
document.addEventListener('DOMContentLoaded', function() {
  const products_on_page = document.getElementById('product-grid');
  const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  let next_url = document.getElementById('paginateNext') ? document.getElementById('paginateNext').dataset.nextUrl : null;

  // Function to fetch the next page content
  async function getNextPage() {
    if (!next_url) {
      console.log('No more pages to load');
      return;
    }

    try {
      let res = await fetch(next_url);
      return await res.text();  // Return the next page as text (HTML)
    } catch (error) {
      console.log('Error fetching the next page:', error);
    }
  }

  // Function to load more products
  async function loadMoreProducts() {
    $('.custom_loader').show();
    $('.custom_loader').css('margin', 'auto');
    load_more_btn.style.display = 'none';  // Hide the button
    load_more_spinner.style.display = 'block';  // Show the spinner

    let nextPage = await getNextPage();  // Fetch next page

    if (!nextPage) return;

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    // Hide the spinner after content is fetched
    load_more_spinner.style.display = 'none';

    // Get the new product elements
    const new_products = nextPageDoc.getElementById('product-grid').getElementsByClassName('grid__item');

    // Get new URL for the next page if available
    const newUrlElement = nextPageDoc.getElementById('paginateNext');
    next_url = newUrlElement ? newUrlElement.dataset.nextUrl : null;

    // Show Load More button again if there's a next page
    if (next_url) {
      $('.custom_loader').hide();
      load_more_btn.style.display = 'inline-flex';
    } else {
      // If no more pages, hide the load more button
      load_more_btn.style.display = 'none';
       $('.custom_loader').hide();
    }

    // Append the new products to the existing list
    for (let i = 0; i < new_products.length; i++) {
      products_on_page.appendChild(new_products[i]);
    }
  }

  // Add event listener to the "Load More" button
  if (load_more_btn) {
    load_more_btn.addEventListener('click', loadMoreProducts);
  }
});
